import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { authCodeFlowConfig } from './auth-code-flow.config';
import { AuthModeService } from './auth-mode.service';
import { getPathFromBrowser, isErrorPath } from './browser-path.util';

/**
 * Prompts the user to log in: IdP mode configures OAuth, loads discovery, then starts the login flow;
 * CoT mode navigates to home. No-op when already on the error page.
 */
@Injectable({ providedIn: 'root' })
export class AuthPromptService {
  constructor(
    private readonly router: Router,
    private readonly oauthService: OAuthService,
    private readonly authModeService: AuthModeService
  ) {}

  promptLogin(force = false): void {
    const pathFromRouter = this.router.url.split('?')[0];
    const pathFromBrowser = getPathFromBrowser();
    if (!force && (pathFromRouter === '/error' || isErrorPath(pathFromBrowser))) {
      return;
    }
    if (this.authModeService.isIdp()) {
      this.oauthService.configure(authCodeFlowConfig);
      this.oauthService.loadDiscoveryDocument()
        .then(() => {
          this.oauthService.initLoginFlow();
        })
        .catch((err) => console.error('[AuthPrompt] loadDiscoveryDocument failed', err));
    } else {
      this.router.navigate(['/']);
    }
  }
}
